import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastService } from './core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastComponent } from './main/shared/toast/toast.component';
import { Subscription } from 'rxjs';
import { OverlayService } from './core/services/overlay.service';
import { LanguageService } from './core/services/language.service';
import { FullscreenOverlayComponent } from './main/components/fullscreen-overlay/fullscreen-overlay.component';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    RouterOutlet,
    ToastComponent,
    FullscreenOverlayComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private toastService: ToastService,
    private overlayService: OverlayService,
    private languageService: LanguageService
  ) {
    const userLang = localStorage.getItem('selectedLanguage') || 'tr';
    this.translate.use(userLang);
  }
  toastMessage: string = '';
  toastType: 'success' | 'error' | 'warning' = 'success';
  showToast: boolean = false;
  isOverlayLoading: boolean = false;
  private subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.toastService.toast$.subscribe((toast) => {
      this.toastMessage = toast.message;
      this.toastType = toast.type;
      this.showToast = toast.showToast;
    });
    this.overlayService.overlayLoading$.subscribe((isLoading) => {
      this.isOverlayLoading = isLoading;
    });
    this.subscriptions.push(
      this.languageService.language$.subscribe((lang) => {
        if (lang) {
          this.translate.use(lang);
        }
      })
    );
  }

  switchLanguage(lang: string) {
    this.translate.use(lang);
  }
}
